<form #newPartnerFtpForm="ngForm" name="newPartnerFtpForm" (ngSubmit)="newPartnerFtpForm.valid && save()" novalidate>
  <h2>New Ftp Account</h2>
  <div class="row">
    <div class="col-sm-6 col-md-3">
      <div class="form-group">
        <label>Username for the Ftp Account</label>
        <div class="input-group">
          <input class="form-control" [ngClass]="{'invalid-state-border':FtpuserName.errors}" name="FtpuserName" #FtpuserName="ngModel" required type="text" [(ngModel)]="username" [readonly]="!canChangeUsername" />
          <span class="input-group-btn">
            <button class="btn btn-default" (click)="generateUsername()" type="button"><ep-svg-icon icon="repeat"></ep-svg-icon></button>
          </span>
        </div>
        @if (FtpuserName.errors && (FtpuserName.dirty || FtpuserName.touched || newPartnerFtpForm.submitted)) {
          <div class="error">Please enter the Username</div>
        }
      </div>

    </div>
  </div>
  <div class="row">
    <div class="col-sm-19 col-md-6">
      @if (showPassword) {
        <div class="form-group">
          @if (showPassword) {
            <app-password decorator name="FtpPassword" caption="Password for the Ftp Account" [allowShowPassword]="false" [(ngModel)]="password"
              infoText="Please enter the password according to {{pluginName}} password complexity requirements">
            </app-password>
          }
        </div>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 col-md-3">
      @if (showUpload) {
        <div class="form-group">
          <label>Choose public key</label>
          <input  name="uploadPublickKey" type="file" #fileInput placeholder="Upload file..." (change)="onPublickKeyChange($event)" />
        </div>
      }
      <div class="form-group">
        <div class="control control-checkbox">
          <label>Exclude Integrated Ftp<input name="excludeFromIntegratedFtpRetrieve" type="checkbox" [(ngModel)]="excludeFromIntegratedFtpRetrieve" /><i></i></label>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">

      <div class="form-group">
        <dx-data-grid [dataSource]='ftpFolders'>
          <dxo-editing mode="row"
            [allowUpdating]="true"
            [allowAdding]="true"
          [allowDeleting]="true"></dxo-editing>
          <dxi-column dataField="folder" caption="Folder" dataType="string" sortOrder="asc" [validationRules]="[{ type: 'required' }]"></dxi-column>
        </dx-data-grid>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <button class="btn btn-primary" type="submit">Save</button>
      <button class="btn btn-link" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</form>
